module.exports = __webpack_public_path__ + "img/address-book.629fc180.svg";